import {getBaseColor, CSSObject} from "@core-ui/react-stitch";
import {DropdownStyleFn} from "../types";

const getArrowSVG: DropdownStyleFn<string> = (props) => {
  const color = getBaseColor("gray60")(props).replace("#", "%23");
  return `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='9' height='6' viewBox='0 0 9 6'%3E%3Cpath d='M.003 1.533L1.118.529l3.385 3.047L7.89.529l1.114 1.004-4.5 4.05z' style='fill:${color};fill-rule:evenodd' /%3E%3C/svg%3E")`;
};

export const arrow: DropdownStyleFn<CSSObject> = (props) => ({
  content: '""',
  background: `${getArrowSVG(props)} no-repeat`,
  width: "1.5rem",
  height: "2rem",
  display: "block",
  position: "absolute",
  right: "1px",
  top: "1px",
  backgroundPositionX: "8px",
  backgroundPositionY: "14px",
});

export const nativeArrow: DropdownStyleFn = (props) => ({
  background: `${getArrowSVG(props)} right 8px center no-repeat`,
});
